<template>
  <div class="modal-card offline-class-players">
    <b-loading :is-full-page="false" v-model="isLoading"></b-loading>

    <header
      class="modal-card-head is-justify-content-space-between is-align-items-start"
    >
      <div
        class="is-flex is-flex-direction-column is-justify-content-space-between is-align-items-start"
      >
        <span class="is-size-5 has-text-info">
          {{ activePlayers.length }}
          {{ tournament.playerLimit ? "/" + tournament.playerLimit : "" }}
          PLAYERS
        </span>
        <span
          class="has-text-danger"
          v-if="
            activePlayers.length &&
            activePlayers.length !== tournament.playerCount
          "
        >
          Mismatched players count: {{ activePlayers.length }} vs
          {{ tournament.playerCount }}
          <button @click="updatePlayerCount">Update</button>
        </span>
      </div>

      <div
        class="is-flex is-justify-content-space-between is-align-items-start"
      >
        <b-field
          label="order by"
          label-position="on-border"
          type="is-info"
          class="mx-4"
        >
          <b-select v-model="orderBy">
            <option value="name" key="orderName">name</option>
            <option value="score" key="orderScore">score</option>
            <option value="seed" key="orderSeed">rating</option>
          </b-select>
        </b-field>

        <b-field
          label="participation"
          label-position="on-border"
          type="is-info"
        >
          <b-select v-model="filterStatus">
            <option :value="null" key="all">all</option>
            <option :value="true" key="yes">participating</option>
            <option :value="false" key="no">absent</option>
          </b-select>
        </b-field>
      </div>
    </header>

    <section class="modal-card-body p-0">
      <div class="p-4" style="background-color: whitesmoke">
        <PlayersProgressBar :playersStats="playersStats" />

        <b-field class="pt-4">
          <b-input
            v-model="filterText"
            placeholder="Type to search for players ..."
            type="search"
            icon="search"
          ></b-input>
        </b-field>

        <div>
          <PlayerTags
            :players="filteredPlayers"
            :totalRounds="tournament.totalRounds"
            :canClose="true"
            @onRemovePlayer="removePlayer"
            v-on="$listeners"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import PlayerTags from "@/components/admins/PlayerTags.vue";
import PlayersProgressBar from "@/components/tournaments/PlayersProgressBar.vue";
import TournamentRoundStats from "@/components/admins/tournaments/TournamentRoundStats.js";
import TournamentCommonData from "@/components/admins/tournaments/TournamentCommonData.js";

export default {
  components: { PlayerTags, PlayersProgressBar },
  name: "TournamentPlayers",

  props: ["tournament", "players"],

  mixins: [TournamentCommonData, TournamentRoundStats],

  data() {
    return {
      isLoading: false,
      orderBy: "score",
      filterText: "",
      filterStatus: null,
    };
  },

  computed: {
    filteredPlayers() {
      let filtered = [...this.players];
      if (this.filterText) {
        filtered = filtered.filter((p) =>
          p.username.includes(this.filterText.toLowerCase())
        );
      }
      if (this.filterStatus !== null) {
        filtered = filtered.filter(
          (p) => p.isParticipating === this.filterStatus
        );
      }
      if (this.orderBy === "score") {
        filtered = filtered.sort(
          (a, b) => b.score - a.score || b.seed - a.seed
        );
      } else if (this.orderBy === "name") {
        filtered = filtered.sort((a, b) =>
          a.username > b.username ? 1 : a.username < b.username ? -1 : 0
        );
      } else if (this.orderBy === "seed") {
        filtered = filtered.sort((a, b) => b.seed - a.seed);
      }
      return [...filtered];
    },
  },

  methods: {
    updatePlayerCount() {
      // TODO: handle this for online tournaments
      this.$emit("onUpdatePlayerCount");
    },

    addPlayer(player) {
      this.$emit("onAddPlayer", player);
    },

    removePlayer(player) {
      this.$emit("onRemovePlayer", player);
    },
  },
};
</script>

<style scoped>
.offline-class-players {
  width: 100%;
  position: relative;
}
</style>
